import React from "react";
import baseUrl from "../../api/universalApi";
import { useSelector } from "react-redux";

const GenerateInvoice = ({ campaignData, contract, setIsInvoice,setPopup }) => {
  const user = useSelector((state) => state.auth?.authData?.user);
  const handleSendInvoice = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/agreement/sendInvoice`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          campaignData,
          contract,
        }),
      });
     // console.log("Response Status:", response);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();

     // console.log("Invoice sent successfully:", data);
      if (data.success) {
        alert("Invoice sent successfully!");
      } else {
        alert("Failed to send invoice: " + data.message);
      }

      setIsInvoice(false);
    } catch (error) {
      console.error("Error sending invoice:", error);
    }
  };

  return (
    <div className="p-3 w-full mx-auto   bg-white rounded-2xl shadow-md text-sm md:text-base">
      <div className="flex flex-row gap-4 mb-4">
        <div className="mb-6 border-b pb-4">
          <h1 className="text-2xl font-bold">Invoice</h1>
          <p className="text-gray-500">
            Campaign: {campaignData?.campaignTitle || "N/A"}
          </p>
          <p className="text-gray-500">Platform: {campaignData?.platform}</p>
          <p className="text-gray-500">Brand: {campaignData?.brandName}</p>
          <p className="text-gray-500">Status: {campaignData?.status}</p>
          <p className="text-gray-500">
            Created At: {new Date(campaignData?.createdAt).toLocaleString()}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div>
            <h2 className="text-xl font-semibold mb-2">Contract Details</h2>
            <p>
              Publish Date: {new Date(contract.publish_date).toLocaleString()}
            </p>
            <p>Start Date: {new Date(contract.start_date).toLocaleString()}</p>
            <p>End Date: {new Date(contract.end_date).toLocaleString()}</p>
            <p>Company Name: {contract.company}</p>
            <p>Payment Type: {contract.paymentType}</p>
            <p>Final Amount: ₹{contract.amount}</p>
            <p>Deliverables: {contract.deliverables}</p>
          </div>
          <div>
            <h2 className="text-xl font-semibold mb-2">Signatures</h2>
            <p>Creator Signature: {contract.creator_signature}</p>
            <p>Brand Signature: {contract.rep_signature}</p>
            <p>Brand Email: {contract.rep_email}</p>
          </div>
        </div>
      </div>

      {user?.userType === "Influencer" ? (
        <button
          onClick={handleSendInvoice}
          className="bg-blue-600 text-white px-6 py-2 rounded-xl hover:bg-blue-700 transition w-full md:w-auto"
        >
          Send Invoice
        </button>
      ) : (
        <button
          onClick={() => setPopup(false)}
          className="bg-gray-300 text-gray-700 px-6 py-2 rounded-xl hover:bg-gray-400 transition w-full md:w-auto"
        >
          Close
        </button>
      )}
    </div>
  );
};

export default GenerateInvoice;
